function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.6 5.6C7.144 5.6 8.4 4.344 8.4 2.8C8.4 1.256 7.144 0 5.6 0C4.056 0 2.8 1.256 2.8 2.8C2.8 4.344 4.056 5.6 5.6 5.6ZM5.6 1.6C6.264 1.6 6.8 2.136 6.8 2.8C6.8 3.464 6.264 4 5.6 4C4.936 4 4.4 3.464 4.4 2.8C4.4 2.136 4.936 1.6 5.6 1.6ZM5.64 9.6H2.216C3.008 9.2 4.376 8.8 5.6 8.8C5.688 8.8 5.784 8.808 5.872 8.808C6.144 8.224 6.616 7.744 7.184 7.36C6.6 7.256 6.048 7.2 5.6 7.2C3.728 7.2 0 8.136 0 10V11.2H5.6V10C5.6 9.864 5.616 9.728 5.64 9.6ZM11.6 7.6C10.128 7.6 7.2 8.408 7.2 10V11.2H16V10C16 8.408 13.072 7.6 11.6 7.6ZM12.568 6.144C13.176 5.8 13.6 5.152 13.6 4.4C13.6 3.296 12.704 2.4 11.6 2.4C10.496 2.4 9.6 3.296 9.6 4.4C9.6 5.152 10.024 5.8 10.632 6.144C10.92 6.304 11.248 6.4 11.6 6.4C11.952 6.4 12.28 6.304 12.568 6.144Z",
  fill: "black",
  fillOpacity: 0.36
});

var SvgRoleIcon = function SvgRoleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roleIcon.a49803f0.svg";
export { ForwardRef as ReactComponent };